<div class="d-flex flex-column flex-root login-container">
    <div class="d-flex flex-column flex-lg-row flex-column-fluid">
        <div class="d-flex flex-lg-row-fluid w-lg-50 bgi-size-cover bgi-position-center" style="background-image: url(assets/media/misc/Abacus-Login-Image.jpg)">
        </div>
        <div class="d-flex flex-column flex-lg-row-fluid w-lg-50 p-10">
            <div class="d-flex flex-center flex-column flex-lg-row-fluid">
                <div class="w-lg-500px p-10">
                    <div class="logo-container">
                    <a href="#" class="mb-0 mb-lg-5 text-center d-flex justify-content-center" draggable="false">
                        <img alt="Logo" src="assets/media/logos/alchemy-logo.png" (click)="navigate()" class="h-490px h-lg-90px mb-5" draggable="false">
                    </a>
                </div>
                <form [formGroup]="forgotPasswordForm"  class="form w-100" novalidate="novalidate" action="#">
                    <div class="text-left mb-11">
                        <h1 class="text-light-bluish-gray fw-bolder mb-3 login1">Forgot Password</h1>
                    </div>
                    <div class="fv-row mb-8 position-relative">
                        <label class="form-label form-label-floating reverse required">Email Address</label>
                        <input type="email" placeholder="" formControlName="mailId" autocomplete="off" class="form-control bg-transparent pass" maxlength="320" />
                
                        @if (forgotPasswordForm.get('mailId')?.invalid && forgotPasswordForm.get('mailId')?.touched) {
                            <span class="text-danger">
                                @if (forgotPasswordForm.get('mailId')?.errors?.['required']) {
                                    Email is required.
                                }
                                @else if (forgotPasswordForm.get('mailId')?.errors?.['maxlength']) {
                                    Emai must be no longer than 320 characters.
                                }
                                @else if (forgotPasswordForm.get('mailId')?.errors?.['email']) {
                                    Please enter a valid email address.
                                }
                            </span>
                        }
                        <!-- @if (showInvalidEmailMessage) {
                            <span class="text-danger">
                              Please enter a valid email address to receive the reset link.
                            </span>
                        } -->
                    </div>

                    <!-- <div *ngIf="isLoading" class="loader-container">
                        <mat-progress-spinner [diameter]="30" mode="indeterminate"></mat-progress-spinner>
                        <span class="loader-text">please wait...</span>
                    </div> -->

                    <div *ngIf="responseMessage" class="response-message">
                        {{ responseMessage }} 
                    </div>
                    <div *ngIf="errorMessage" class="err-message">
                        {{ errorMessage }}
                    </div>
                
                    <div class="d-grid mb-10">
                        @if(!isSubmitClicked()){
                        <button type="submit" class="btn btn-primary" (click)="onForgotPassword()">
                            <span class="indicator-label">Submit</span>
                        </button>
                        } @else {
                        <button type="submit" class="btn btn-primary" (click)="navigate()">
                            <span class="indicator-label">Login</span>
                        </button>
                        }
                    </div>                    
                </form>
                </div>
            </div>
            <div class="d-flex flex-center flex-wrap px-5">
        <div class="d-flex fw-semibold text-light-gray fs-base">
            <span class="px-5" target="_blank">© 2025 Alchemy Underwriting. All rights reserved.</span>
        </div>
    </div>
        </div>
    </div>
</div>